import IEntity from "./Entity";
import IMei from "./IMei";

export default interface IInvoiceAggregation extends IEntity {
	mei: string | IMei;
	year: string;
	total: number;
	status: InvoiceAggregationStatus;
}

export enum InvoiceAggregationStatus {
	WithinLimit = 0,
	AtLimit = 1,
	OverLimit = 2
}
